import Layout from '@/components/layout/Index'
export default [
  {
    path: '/space',
    name: 'space',
    component: Layout,
    redirect: '/space/files/list',
    children: [
      {
        path: 'files', // 工程管理
        name: 'space_files',
        component: () => import('@/views/CommonView.vue'),
        meta: { title: '工程管理', icon: 'home', noCache: true, keepAlive: false, auth: true },
        children: [
          {
            path: 'list', // 个人文件
            name: 'space_files_list',
            component: () => import('@/views/space/files/children/List.vue'),
            meta: { title: '员工文件库', icon: 'home', noCache: true, keepAlive: false, auth: true }
          },
          {
            path: 'recycle',
            name: 'space_recycle',
            component: () => import('@/views/space/Recycle.vue'),
            meta: { title: '回收站', icon: 'home', noCache: true, keepAlive: false, auth: true }
          }
        ]
      },
      {
        path: 'database', // 员工数据
        name: 'space_data',
        // redirect: '/space/database/inventory',
        component: () => import('@/views/CommonView.vue'),
        meta: { title: '员工数据', icon: 'home', noCache: true, keepAlive: false, auth: true },
        children: [
          {
            path: 'test', // 清单数据
            name: 'test',
            component: () => import('@/views/space/database'),
            meta: { title: '上传测试', icon: 'home', noCache: true, keepAlive: false, auth: true }
          },
          {
            path: 'inventory', // 清单数据
            name: 'space_data_inventory',
            component: () => import('@/views/database/children/basis/Inventory.vue'),
            meta: { title: '清单数据', icon: 'home', noCache: true, keepAlive: false, auth: true }
          },
          {
            path: 'quota', // 定额数据
            name: 'space_data_quota',
            component: () => import('@/views/database/children/basis/Quota.vue'),
            meta: { title: '定额数据', icon: 'home', noCache: true, keepAlive: false, auth: true }
          },
          {
            path: 'material', // 人材机数据
            name: 'space_data_material',
            component: () => import('@/views/database/children/basis/Material.vue'),
            meta: { title: '人材机数据', icon: 'home', noCache: true, keepAlive: false, auth: true }
          },
          {
            path: 'combination', // 组价数据
            name: 'space_data_combination',
            component: () => import('@/views/database/children/basis/Combination.vue'),
            meta: { title: '组价数据', icon: 'home', noCache: true, keepAlive: false, auth: true }
          }
        ]
      }
    ]
  },
  {
    path: '/space2/guide',
    name: 'spaceGuide',
    component: () => import('@/views/space/Guide.vue')
  }
]
